
export default [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'password',
        field: 'senha',
        label: 'Digite sua senha para continuar',
        placeholder: '',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'textarea',
        field: 'obs',
        label: 'Informe abaixo o motivo do cancelamento da consulta',
        placeholder: '',
        maxlength: 1000,
        rows: 5,
        rules: ['required']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/credenciada/consulta/_form/consulta-config-cancelar.js